<template>
	<div style="width: 100%">
		<div style="display: flex">
			<app-total
				style="margin-top: auto; margin-bottom: auto"
				:start="0"
				:end="array.length"
				:total="isSuperAdmin ? array.length : MAX_USERS"
			/>
			<el-popover style="margin-top: 2px" trigger="hover" placement="top" v-if="!isSuperAdmin">
				<div slot="reference">
					<i class="el-icon-warning-outline icon-button" />
				</div>
				<div>
					<div v-html="count_user_left" />
				</div>
			</el-popover>
		</div>
		<div>
			<div class="header">
				<div class="header_title-container title">
					<h1>{{ $t("users") }}</h1>
				</div>
				<div class="header_actions">
					<div class="header_actions-container">
						<option-button
							:buttons="buttons"
							:show="true"
							@add="add = true"
							@archive="deleting = true"
							@restore="restore = true"
							@clear="handleClear"
						/>
					</div>
				</div>
			</div>
		</div>
		<div>
			<md-table v-model="array" style="font-family: 'Montserrat', sans-serif">
				<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
					<md-table-cell width="25">
						<md-checkbox
							v-if="item.id != user.id"
							:id="item.id"
							v-model="selecteds"
							:value="item"
							@click="e => e.stopPropagation()"
						></md-checkbox>
					</md-table-cell>
					<md-table-cell :md-label="$t('id').toUpperCase()" width="50">
						<span v-if="item.approved && item.confirmed">{{ item.id }}</span>
						<el-tag v-else type="warning">{{ $t("waiting-to-confirm") }}</el-tag>
						<el-tag
							v-if="item.reset_code.String && isSuperAdmin"
							type="error"
							style="margin-top: 10px"
							@click="e => copyToClipboard(item.reset_code.String)"
							>{{ $t("ask-reset-password") }}</el-tag
						>
					</md-table-cell>
					<md-table-cell :md-label="$t('name').toUpperCase()">{{ item.username }}</md-table-cell>
					<md-table-cell :md-label="$t('email').toUpperCase()">{{ item.email }}</md-table-cell>
					<md-table-cell :md-label="$t('deleted-at').toUpperCase()" width="150">
						{{ item.deleted_at ? moment(item.deleted_at).format("DD-MM-YYYY") : "" }}
					</md-table-cell>
					<md-table-cell width="25">
						<option-table-button
							placement="right"
							v-if="item.id != user.id"
							:buttons="getTableRowButtons(item)"
							:item="item"
							@block="
								value => {
									if (!value) block = item
									else restore = item
								}
							"
							@delete="deleting = item"
							@restore="restore = item"
							@confirm="
								() => {
									resendEmailUser(item)
								}
							"
						/>
					</md-table-cell>
				</md-table-row>
			</md-table>
		</div>
		<div v-if="array.length == 0">
			{{ $t("empty-result") }}
		</div>
		<!-- ADD USER -->
		<div v-if="add">
			<add-user :show="add" :organization="element" @close="add = false" @add="handleAdd" />
		</div>
		<!-- DELETE / RESTORE CONFIRM MODAL -->
		<div v-if="deleting || restore">
			<delete-confirm-modal @close="handleFunction" :title="title" :content="content" />
		</div>
	</div>
</template>
<script>
import axios from "axios"
import moment from "moment"
import { mapActions, mapGetters } from "vuex"
import OptionButton from "@/modules/_common/button/option-button.vue"
import AddUser from "./add-user.vue"
import AddButton from "@/modules/_common/button/add-button.vue"
import OptionTableButton from "@/modules/_common/button/option-table-button.vue"
import AppTotal from "@/modules/_common/table/app-total.vue"
import DeleteConfirmModal from "@/modules/_common/modal/delete-confirm-modal.vue"

export default {
	name: "school-users-table",
	components: {
		DeleteConfirmModal,
		OptionButton,
		AddUser,
		AddButton,
		OptionTableButton,
		AppTotal
	},
	props: ["element"],
	data() {
		return {
			height: window.innerHeight - 325,
			array: [],
			selecteds: [],
			block: undefined,
			restore: undefined,
			deleting: undefined,
			add: false,
			buttons: ["add"],
			MAX_USERS: 5
		}
	},
	computed: {
		...mapGetters({
			user: "user/user",
			roles: "organization/roles",
			maximum: "organization/maximum",
			isSuperAdmin: "user/isSuperAdmin"
		}),
		count_user_left: function () {
			var filtered = this.array.filter(a => a.deleted_at == undefined)
			if (filtered.length < this.MAX_USERS)
				return this.$t("left-users").replace("%COUNT%", this.MAX_USERS - filtered.length)
			else return this.$t("reached-users-limit")
		},
		title: function () {
			if (this.deleting) return this.$t("blocking-user")
			else if (this.restore) return this.$t("restoring-user")
		},
		content: function () {
			if (this.deleting) return this.$t("are-you-sure-block-user")
			else if (this.restore) return this.$t("are-you-sure-restore-user")
		}
	},

	watch: {
		element: function () {
			if (this.element == undefined) {
				this.add = false
				this.selecteds = []
			}
		},
		selecteds: function () {
			if (this.selecteds.length > 0) {
				if (this.selecteds.every(el => el.deleted_at != undefined)) this.buttons = ["clear", "restore"]
				else this.buttons = ["clear", "archive"]
			} else {
				if (this.array.length < this.MAX_USERS) this.buttons = ["add"]
			}
		}
	},

	async created() {
		this.array = await this.doUsers(this.element ? this.element.id : undefined).catch(err => {
			console.error(err)
			this.$processError("users limit", err)
		})
	},

	methods: {
		...mapActions({
			doUsers: "organization/doUsers"
		}),
		moment,
		handleClear: function () {
			this.selecteds = []
			this.block = undefined
			this.deleting = undefined
			this.restore = undefined
			this.buttons = ["add"]
		},

		handleFunction(value) {
			if (!value) {
				this.deleting = undefined
				this.restore = undefined

				return
			}
			if (this.deleting) this.handleDelete(value)
			else if (this.restore) this.handleRestore(value)
		},

		handleDelete: function (value) {
			if (!value) {
				this.deleting = undefined
				this.block = undefined
				this.selecteds = []
			}
			var el = this.block || this.deleting
			if (el == undefined && this.selecteds.length == 0) return
			var array = this.selecteds.length > 0 ? this.selecteds : [el]

			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/user/batchDelete",
					{ array: array },
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					for (var i = 0; i < this.array.length; i++) {
						if (res.data.deleted && res.data.deleted.includes(this.array[i].id))
							this.array[i].deleted_at = new Date()
					}
					this.$notification("success", this.$t("blocked-user-successful"), "", 4000)
					this.selecteds = []
				})
				.catch(err => {
					this.$processError(this.$t("delete-error"), err.response.data.Message)
					console.error(err)
				})

			this.handleClear()
		},

		handleRestore: function (value) {
			if (!value) {
				this.restore = undefined
				this.selecteds = []
			}
			if (this.restore == undefined && this.selecteds.length == 0) return
			var array = this.selecteds.length > 0 ? this.selecteds : [this.restore]

			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/user/batchRestore",
					{ array: array },
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					for (var i = 0; i < this.array.length; i++) {
						if (res.data.restored && res.data.restored.includes(this.array[i].id))
							this.array[i].deleted_at = undefined
					}
					this.$notification("success", this.$t("restore-user-successful"), "", 4000)
					this.selecteds = []
				})
				.catch(err => {
					this.$processError(this.$t("restore-error"), err.response.data.Message)
					console.error(err)
				})

			this.restore = undefined
			this.selecteds = []
		},

		handleAdd: function (user) {
			this.array.push(user)
			this.add = false
		},
		resendEmailUser(item) {
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/user/resendemail",
					{
						id: item.id,
						language: localStorage.getItem("lang")
					},
					{
						headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
					}
				)
				.then(res => {
					if (res.data) {
						this.$notification("success", this.$t("sent-email"), "", 4000)
					} else {
						this.$notification("error", this.$t("error-email"), "", 0)
					}
				})
				.catch(err => this.$notification("error", this.$t("error-email"), "", 0))
		},
		getTableRowButtons: function (item) {
			var r = []

			if (!item.confirmed && this.isSuperAdmin) {
				r.push("confirm")
			}

			if (item.deleted_at == undefined) r.push("delete")
			else r.push("restore")

			return r
		},
		copyToClipboard: function (string) {
			navigator.clipboard.writeText(process.env.VUE_APP_FRONTEND + "/#/resetpassword/" + string)
			this.$notification("success", this.$t("text-copied"), this.$t("text-copied-string"), 6000)
		}
	}
}
</script>
<style scoped lang="scss">
@import "src/assets/scss/my-menu";

.icon-button {
	padding: 7px;

	&:hover {
		cursor: pointer;
		background-color: #fefefe;
		border-radius: 50%;
	}
}
</style>
